import React from 'react';
import BonCadeau from '../BonCadeau';

function BonCadeauPage() {
    return (
        <>
            <BonCadeau />
        </>
    )
}

export default BonCadeauPage;
